<div fxLayout="column" fxLayoutAlign="center center" class="neutral-theme">
  <div class="title-container" fxLayout="column" fxLayoutAlign="center center">
    <h1 *ngIf="!inPreviewMode">{{ survey?.publicTeamName ? survey.publicTeamName : survey?.teamName }}</h1>
    <h2>{{ survey?.title }}</h2>
    <div
      class="banner"
      fxLayout="row"
      fxLayoutAlign="center center"
      *ngIf="survey?.form.isAnonymousSurvey && !survey?.hasCompleted"
    >
      <mat-icon>info</mat-icon>
      <span>Your responses are anonymous.</span>
    </div>
  </div>
  <div *ngIf="isLoadingOrSaving" class="waiting-spinner">
    <mat-spinner strokeWidth="2" diameter="50"></mat-spinner>
  </div>
  <div *ngIf="!isLoadingOrSaving && !inPreviewMode" class="survey">
    <router-outlet></router-outlet>
  </div>

  <div *ngIf="!isLoadingOrSaving && inPreviewMode" class="survey">
    <survey-introduction
      *ngIf="surveyHasIntroduction"
      [inPreviewMode]="inPreviewMode"
      (previewSurveyStart)="startSurvey()"
    >
    </survey-introduction>
    <survey-respond *ngIf="isSurveyStarted" [inPreviewMode]="inPreviewMode" (previewSurveySave)="saveSurvey()">
    </survey-respond>
    <survey-confirmation *ngIf="surveySaved" [inPreviewMode]="inPreviewMode"> </survey-confirmation>
  </div>
</div>
